import React from "react";
import { SLIDE_TYPES } from "../constants/slideTypes";
import CoverEditor from "./editors/CoverEditor";
import InclusionsEditor from "./editors/InclusionsEditor";
import ExclusionsEditor from "./editors/ExclusionsEditor";
import FlightDetailsEditor from "./editors/FlightDetailsEditor";
import HotelDetailsEditor from "./editors/HotelDetailsEditor";
import TransportDetailsEditor from "./editors/TransportDetailsEditor";
import ItineraryEditor from "./editors/ItineraryEditor";
import PaymentTermsPolicyEditor from "./editors/PaymentTermsPolicyEditor";
import TermsConditionsEditor from "./editors/TermsConditionsEditor";
import ThankYouEditor from "./editors/ThankYouEditor";

const SlideEditorRenderer = ({
  slide,
  updateSlide,
  removeSlide,
  triggerSave,
}) => {
  switch (slide.type) {
    case SLIDE_TYPES.COVER:
      return (
        <CoverEditor
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.INCLUSIONS:
      return (
        <InclusionsEditor
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.EXCLUSIONS:
      return (
        <ExclusionsEditor
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.FLIGHTS:
      return (
        <FlightDetailsEditor
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.HOTELS:
      return (
        <HotelDetailsEditor
          key={slide.id}
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.TRANSPORT:
      return (
        <TransportDetailsEditor
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.ITINERARY:
      return (
        <ItineraryEditor
          key={slide.id}
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.POLICY:
      return (
        <PaymentTermsPolicyEditor
          key={slide.id}
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.TERMS:
      return (
        <TermsConditionsEditor
          key={slide.id}
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );
    case SLIDE_TYPES.THANKYOU:
      return (
        <ThankYouEditor
          key={slide.id}
          slide={slide}
          updateSlide={updateSlide}
          removeSlide={removeSlide}
          triggerSave={triggerSave} 
        />
      );

    default:
      return <div>Unknown editor</div>;
  }
};

export default SlideEditorRenderer;
